import script from "./CollectionDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./CollectionDetailPage.vue?vue&type=style&index=0&id=564abf12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564abf12"]])

export default __exports__